// constants
import { APP_NAME } from './constants';

// types
import type { StateTree } from '@makemydeal/dr-dash-types';

/**
 * Gets the total count of deals across all vehicle groups
 * This is a local copy for use in isDealsButtonVisible
 */
export const getCustomerFirstName = (state: any): string | undefined => state?.[APP_NAME]?.customerFirstName;

/**
 * Gets the total count of deals across all vehicle groups.
 * Maintained by the customerVehicles reducer (derived from `deals` on FETCH_DEALS_SUCCESS).
 */
export const getDealsCount = (state: any): number => state?.[APP_NAME]?.dealsCount ?? 0;

/**
 * Determines if the deals button should be visible in the header
 * Returns true if the feature toggle is enabled and there is at least one deal
 */
export const isDealsButtonVisible = (state: StateTree): boolean => {
    return getDealsCount(state) > 0;
};

/**
 * Gets the selected deal id kept fresh by the FETCH_DEALS_SUCCESS sync in middleware.ts
 */
export const getSelectedDealId = (state: any): string | undefined => state?.[APP_NAME]?.selectedDealId;

/**
 * Gets the selected deal version kept fresh by the FETCH_DEALS_SUCCESS sync in middleware.ts
 */
export const getSelectedDealVersion = (state: any): string | undefined => state?.[APP_NAME]?.selectedDealVersion;
